import { useState } from 'react';

import {
  BpkButtonV2,
  BUTTON_TYPES,
} from '@skyscanner/backpack-web/bpk-component-button';

import FiltersAndSortSelectors from '../../../FiltersAndSortSelectors';
import HotelRating from '../../../HotelRating';
import ReviewImages from '../../../ReviewImages';
import ReviewProviders from '../../../ReviewProviders';
import ViewMoreReviewsLink from '../../../ViewMoreReviewsLink';

import InfiniteScrollReviews from './InfiniteScrollReviews';

import type { HotelReviewSummary } from '@shared/types/hotel-content';
import type { I18nService } from '@shared/types/i18n';
import type { Nullable } from '@shared/types/utils';

import STYLES from './ReviewsCustomizeMobile.module.scss';

import {
  useHotelReviewsContext,
  useShowFilters,
  useTaReview,
} from '@hotels-hotel-detail/data-access/hooks/useHotelReviewsContext';
import EndTip from '@hotels-hotel-detail/ui/EndTip';
import { withI18n } from '@shared/ui/contexts/i18n';

type Props = {
  reviewSummary: Nullable<HotelReviewSummary>;
  i18n: I18nService;
};

const ReviewsCustomizeMobile = ({ i18n, reviewSummary }: Props) => {
  const [isListFinished, setIsListFinished] = useState(false);
  const { error, isLoading, reload } = useHotelReviewsContext();
  const showFilters = useShowFilters();
  const lastPage = isListFinished && !isLoading;
  const taReview = useTaReview();
  const shouldShowTaLink = lastPage && !!taReview;

  return (
    <div className={STYLES.ReviewsCustomizeMobile}>
      {reviewSummary && reviewSummary.score > 0 && (
        <div className={STYLES.ReviewsCustomizeMobile__ratingWrapper}>
          <HotelRating showRatingTitle={false} reviewSummary={reviewSummary} />
        </div>
      )}
      <ReviewProviders height={30} />
      <ReviewImages useLighterTitle />
      {showFilters && <FiltersAndSortSelectors />}
      <div className={STYLES.ReviewsCustomizeMobile__reviewCardList}>
        {error ? (
          <div className={STYLES.ReviewsCustomizeMobile__bottomButton}>
            <BpkButtonV2
              type={BUTTON_TYPES.secondary}
              onClick={() => reload?.()}
            >
              {i18n.translate('Button_refreshSearch')}
            </BpkButtonV2>
          </div>
        ) : (
          <InfiniteScrollReviews
            onScrollFinished={() => setIsListFinished(true)}
          />
        )}
      </div>
      {shouldShowTaLink && <ViewMoreReviewsLink />}
      {lastPage && <EndTip />}
    </div>
  );
};

export default withI18n(ReviewsCustomizeMobile);
